module.exports = __webpack_public_path__ + "src/class2/img/loading-2.8da3562e.png";